import React from 'react'
import { StyleService } from '@src/style/service'
import { BottomSheet } from '@components'
import { Text } from '@components/base'

interface GestureDismissibleAlertModalProps {
  title: string
  description: string
  actionTitle: string
  dismissButtonText?: string
  onActionPress: () => void
}

export const GestureDismissibleAlertModal = ({
  title,
  description,
  actionTitle,
  dismissButtonText,
  onActionPress,
}: GestureDismissibleAlertModalProps) => {
  return (
    <BottomSheet
      showDismissButton
      dismissButtonPosition="top"
      dismissButtonText={dismissButtonText}
      primaryButton={{
        text: actionTitle,
        onPress: onActionPress,
      }}
    >
      <Text type="title-2" style={styles.title}>
        {title}
      </Text>
      <Text type="large" style={styles.description}>
        {description}
      </Text>
    </BottomSheet>
  )
}

const styles = StyleService.create({
  title: {
    textAlign: 'center',
    marginTop: 16,
  },
  description: {
    marginVertical: 32,
    textAlign: 'center',
  },
})
